export default __webpack_public_path__ + "static/media/lato-italic.eed2bb8d.woff2";